import React, { useState, useEffect } from 'react';
import { useIntl, useLocation } from 'umi';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import Revenue from './Revenue';
import Downloads from './Downloads';
import Mentions from './Mentions';
import { updatePathURLByPageId } from './utils';
import '@/pages/intelligence/assets/scss/TopCharts/Companies/index.scss';

const { Content } = Layout;

export default function Companies(props: any) {
  const location = useLocation();
  const search = location?.search;
  const { formatMessage } = useIntl();

  const tabs = [
    { id: 'Revenue', label: formatMessage({ id: 'dbi_revenue' }), component: <Revenue /> },
    { id: 'Downloads', label: formatMessage({ id: 'dbi_downloads' }), component: <Downloads /> },
    // { id: 'Mentions', label: formatMessage({ id: 'dbi_mentions' }), component: <Mentions /> },
  ];

  const initialActiveId = (() => {
    const urlActiveId = props?.match?.params?.tab;
    const activeIds = tabs?.map((tab) => tab?.id);
    return activeIds?.includes(urlActiveId) ? urlActiveId : tabs?.[0]?.id;
  })();

  const [activeId, setActiveId] = useState(initialActiveId);

  return (
    <Content>
      <Content.Header title={formatMessage({ id: 'dbi_company_companies' })} className="contentHead-normal">
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="TopChartsCompanies"
            tabs={tabs}
            animated={false}
            activeId={activeId}
            onActive={(tab) => {
              const activeIdTemp = tab?.id;
              setActiveId(activeIdTemp);
              updatePathURLByPageId(activeIdTemp);
            }}
          />
        </div>
      </Content.Header>
      <Content.Body full>
        {tabs.map((e) => (
          <div key={e?.id}>{e?.id === activeId && e?.component}</div>
        ))}
      </Content.Body>
    </Content>
  );
}
